import CryptoJS from 'crypto-js';

import { credentialsKey } from '../resources/environmentConstants';

/**
 * @param {String} text Text to encrypt
 * @returns {String} Encrypted text
 */
const encrypt = (text) => {
  const key = CryptoJS.enc.Utf8.parse(credentialsKey);
  const iv = CryptoJS.enc.Utf8.parse(credentialsKey);

  const encryptedpassword = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(text), key, {
    keySize: 128 / 8,
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  return encryptedpassword.toString();
};

export default encrypt;
